module.exports = __webpack_public_path__ + "static/media/noun_Shopping Cart_plus-black.d2ad680a.svg";